import { APIClientServices } from "./APIClientServices";

export type PromptAgent = "assistant" | "leader" | "member";
export type PromptVariant = "base" | "runtime";

export interface PromptTemplateDTO {
	id: string;
	agent: PromptAgent;
	variant: PromptVariant;
	content: string;
	version: number;
	isActive: boolean;
	updatedBy: string | null;
	notes: string | null;
	createdAt: string;
	updatedAt: string;
}

export class PromptTemplateServices {
	private static readonly BASE = "v1/backoffice/prompts";

	static async list(): Promise<PromptTemplateDTO[]> {
		return APIClientServices.get<PromptTemplateDTO[]>(this.BASE);
	}

	static async get(agent: PromptAgent, variant: PromptVariant): Promise<PromptTemplateDTO> {
		return APIClientServices.get<PromptTemplateDTO>(`${this.BASE}/${agent}/${variant}`);
	}

	static async update(agent: PromptAgent, variant: PromptVariant, content: string, notes?: string): Promise<PromptTemplateDTO> {
		return APIClientServices.put<PromptTemplateDTO>(`${this.BASE}/${agent}/${variant}`, {
			content,
			notes: notes ?? null,
		});
	}

	static async history(agent: PromptAgent, variant: PromptVariant, limit?: number): Promise<PromptTemplateDTO[]> {
		const qs = limit ? { limit } : undefined;
		return APIClientServices.get<PromptTemplateDTO[]>(`${this.BASE}/${agent}/${variant}/history`, qs as any);
	}

	static async rollback(agent: PromptAgent, variant: PromptVariant, version: number): Promise<PromptTemplateDTO> {
		return APIClientServices.post<PromptTemplateDTO>(`${this.BASE}/${agent}/${variant}/rollback/${version}`, {});
	}
}
